import { render, staticRenderFns } from "./SelfView.vue?vue&type=template&id=309fd470&scoped=true&"
import script from "./SelfView.vue?vue&type=script&lang=js&"
export * from "./SelfView.vue?vue&type=script&lang=js&"
import style0 from "./SelfView.vue?vue&type=style&index=0&id=309fd470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309fd470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VIcon,VSimpleTable})
